import React from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { Stories } from 'apps/auth/components/common/Layout/Stories/Stories';
import StoryLayout from 'apps/auth/components/common/Layout/Stories/StoryLayout';
import { AUTH_PLUS_MAIN_PAGE } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import usePreloadStoryImages from 'apps/auth/hooks/usePreloadStoryImages';

const PaysendPlusStories = (props) => {
    const { notNowButton, subscribe } = usePageMessages();
    const { plusPromoSliders } = useExtra();
    const slides = plusPromoSliders?.slides;
    const duration = plusPromoSliders?.duration * 1000;
    const imagesLoaded = usePreloadStoryImages(slides);
    const hasTopButton = plusPromoSliders?.not_now;

    const getSteps = () => {
        let steps = [];
        if (slides) {
            steps = slides.map((slide) => {
                return (
                    <StoryLayout
                        key={slide.order}
                        topButtonCaption={hasTopButton ? notNowButton : null}
                        onTopButtonClick={props.closeModal}
                        title={slide.title}
                        contentPosition={slide.position}
                        subtitle={<DangerouslyHtml dangerouslyHtml={slide.subtitle} />}
                        imgA={slide.web_a_bg_img_url}
                        imgA2x={slide.web_a2x_bg_img_url}
                        imgB={slide.web_b_bg_img_url}
                        imgB2x={slide.web_b2x_bg_img_url}
                        bottomButtonCaption={subscribe}
                        href={AUTH_PLUS_MAIN_PAGE}
                        variant="secondary_base"
                    />
                );
            });
        }
        return steps;
    };

    return <>{imagesLoaded && <Stories steps={getSteps()} isInverted infinityLoop duration={duration} />}</>;
};

PaysendPlusStories.propTypes = {
    closeModal: PropTypes.func,
};
export default PaysendPlusStories;
